/**
 * /whatsapp-broadcast — Canal de difusión de WhatsApp.
 * Checkout MP sin email → /registro post-pago.
 */

import WhatsAppBroadcastTemplate from "@/components/templates/WhatsAppBroadcastTemplate";

export default function WhatsAppBroadcast() {
  return <WhatsAppBroadcastTemplate />;
}
